<template>
    <tr  class="black_line">
        <td class="nameCol">
            <input
                class="name" 
                v-model="model.name" 
                type="text" 
                @change="changeVal('name', model.name)"
            />
        </td>
        <td class="valCol">
           <input
                class="password" 
                v-model="model.password"                 
                @change="changeVal('password', model.password)"
            />
        </td>
        <td class="defValCol">
            <button v-show="!isAdmin" @click="delItem" data-v-06cea251="" class="btn btn-border">DELETE</button>            
        </td>        
    </tr>
</template>

<script>

import {bus} from '../../bus';

export default {
    props: [
        'user',
        'isAdmin'
    ],
    data(){
        return{
            model: {               
                id: '',
                name: '',
                password: ''
            },
            newData: {},
            cur_del_id: ''
        }
    },    
    methods: {       
        delItem(id){            
            this.cur_del_id = this.user.id;            
            bus.$emit('openalert', {
                open: true,
                alert_title: 'Delete this user?',
                alert_text: 'This process cannot be undone.',
                action: 'del_user'
            });            
        },
        delItemAction(id){            
             axios.delete(
                `/users/${this.cur_del_id}`,
                {id: id},
                {headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}}
            ).then((response)=>{
                console.log('del response data: ', response.data)
                this.cur_del_id = '';
                bus.$emit('userDeleted');
            }).catch(function(e){
                console.log('FAILURE!!');
                console.log(e);
            });            
        },
        changeVal(valName, val){            
            this.newData[valName] = val;
            console.log('this.newData', this.newData);
        }
    },
    mounted(){
        
        this.model = this.user;
        
        bus.$on('resultalert', (data) => {            
            if(
                data.action == 'del_user' && 
                this.cur_del_id &&
                data.confirm
            )
                this.delItemAction(this.cur_del_id);

            this.cur_del_id = '';
                        
        });


        bus.$on('updateUser', () => {            
            if(Object.keys(this.newData).length !== 0){                
                
                console.log( 'this.newData: ', this.newData);
                axios.put( `/users/${this.user.id}`,
                    this.newData
                ).then((response)=>{
                    console.log('update user', response);
                    console.log('update user response.data', response.data);
                    this.newData = {};
                    
                    this.model.password = '';

                    alert(`${this.user.name} saved`);
                }).catch(function(error){
                    console.log('FAILURE update person: ');
                    console.log(error);
                });
            }
        });
    },
     computed: {
     }
}
</script>

<style lang="scss" scoped>
    input {
        color: #E0E0E0;
        border: none;
    }
    input.description, {
        border: none;
    }
    
    input.password {
        border-bottom: 1px solid #fff;
    }
    input.custom_number  {
        width: 90px;
        margin-left: 10px;
        border-left: none;
        border-top: none;
        border-right: none;
        padding-bottom: 5px;
    }
    input[type="radio"],
    label
    {
        cursor: pointer;
    }
    .valCol {
        width: 170px;
    }
    .defValCol {
        width: 160px;
    }
    .nameCol {
        width: 200px;
    }
    .custom_checkbox + label::before {
        content: "";
        display: inline-block;
        width: 1em;
        height: 1em;
        flex-shrink: 0;
        flex-grow: 0;
        border: 1px solid #074af8;
        border-radius: 0.25em;
        margin-right: 15px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 70% 70%;
    }
    .custom_checkbox + label {
        display: inline-block;
        margin-top: 3px;
    }
</style>
